<template>
  <div :class="'flex flex-col ' + size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value" :errorMessage="errorMessage">
      <Autocomplete
        v-on:keydown.enter.prevent
        v-model="value"
        :name="props.name"
        :id="props.name"
        multiple
        :typeahead="false"
        class="min-h-10"
        :disabled="props.disabled"
        pt:pcchip:root:class="h-7! mb-1"
      ></Autocomplete>
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-danger-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  disabled: false,
});

const { value, errorMessage } = useField<string[]>(() => props.name);
</script>
